import React from 'react';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button, Box } from '@mui/material';
import LockClockOutlinedIcon from '@mui/icons-material/LockClockOutlined';
import { useTranslation } from 'react-i18next';

const SessionExpiredModal = ({ isOpen, onSignBackIn }) => {
    const { t } = useTranslation();

    return (
        <Dialog 
            open={isOpen} 
            // Prevent closing by clicking outside or pressing escape
            disableEscapeKeyDown
            PaperProps={{
                sx: {
                    backgroundColor: 'var(--tertiary-color, #1f2937)',
                    color: 'white',
                    borderRadius: '12px',
                    border: '1px solid rgba(255,255,255,0.1)',
                    maxWidth: '400px',
                    textAlign: 'center',
                    padding: '16px'
                }
            }}
            slotProps={{
                backdrop: {
                    sx: {
                        backdropFilter: 'blur(8px)',
                        backgroundColor: 'rgba(0, 0, 0, 0.7)'
                    }
                }
            }}
        >
            <Box sx={{ mt: 2, mb: 1 }}>
                <LockClockOutlinedIcon sx={{ fontSize: 60, color: 'var(--secondary-color, #4fc3f7)' }} />
            </Box>
            <DialogTitle sx={{ fontWeight: 'bold', fontSize: '1.5rem', pb: 1 }}>
                {t('sessionExpired.title', 'Session Expired')}
            </DialogTitle>
            <DialogContent>
                <DialogContentText sx={{ color: 'rgba(255, 255, 255, 0.7)', mb: 2 }}>
                    {t('sessionExpired.description', 'For your security, your login session has expired. Please sign back in to continue where you left off.')}
                </DialogContentText>
            </DialogContent>
            <DialogActions sx={{ justifyContent: 'center', pb: 2 }}>
                <Button 
                    onClick={onSignBackIn} 
                    variant="contained" 
                    fullWidth
                    sx={{ 
                        backgroundColor: 'var(--secondary-color, #4fc3f7)', 
                        color: 'white',
                        fontWeight: 'bold',
                        padding: '10px',
                        textTransform: 'none',
                        fontSize: '1rem',
                        '&:hover': { backgroundColor: 'var(--btn-hover-color, #0288d1)' }
                    }}
                >
                    {t('sessionExpired.button', 'Sign Back In')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default SessionExpiredModal;